import { render } from "./EntriesPerPage.vue?vue&type=template&id=8983f824"
import script from "./EntriesPerPage.vue?vue&type=script&lang=js"
export * from "./EntriesPerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__